__turbopack_context__.v({
  "apps-card-title": "AppsCard-module__I1f7WG__apps-card-title",
});
